import React from 'react';
import { PropTypes } from 'prop-types';

const SectionHeader = ({ title, children }) => {
    return (
        <header className="section-header">
            <h1>{title}</h1>
            {children}
        </header>
    )
};

SectionHeader.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node
};

export default SectionHeader;


// WEBPACK FOOTER //
// ./src/components/common/SectionHeader.js